// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-420656cd] .selectLabel .el-input__inner {\n  border: 0;\n  font-weight: bold;\n  padding-left: 0;\n  padding-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
